export default __webpack_public_path__ + "static/media/Open-MOOC-English-for-Media-Literacy.e50c47ad.webp";